import React from 'react';
import Navbar from './NavBar';
import Footer from './Footer';
import { Analytics } from "@vercel/analytics/react"

const StandardLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow max-w-5xl container mx-auto sm:p-6 md:p-8 lg:p-10">
        {children}
      </main>
      <Analytics />
      <Footer />
    </div>
  );
};

export default StandardLayout;